import { Terms } from "@/features/misc";
import Head from "next/head";

export default function TermsPage() {
	return (
		<>
			<Head>
				<title>利用規約 | ケアミー</title>
			</Head>

			<Terms />
		</>
	);
}
